import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from '../../common/page-header/page-header.component';
import { ScreenType, SposobNadaniaType } from 'src/app/enums/enums';
import { SubmitButtonComponent } from '../../common/submit-button/submit-button.component';
import { firstValueFrom } from 'rxjs';
import { ErrorResponse } from 'src/app/models/error/error-response.model';
import { LabelRequest } from 'src/app/models/label/label-request.model';
import { LabelResponse } from 'src/app/models/label/label-response.model';
import { ApiService } from 'src/app/services/api.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { CaptchaDialogService } from 'src/app/services/captcha-dialog.service';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-pickup-confirmation-page',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent, SubmitButtonComponent],
  templateUrl: './pickup-confirmation-page.component.html',
  styleUrl: './pickup-confirmation-page.component.scss',
})
export class PickupConfirmationPageComponent {
  SposobNadaniaType = SposobNadaniaType;

  constructor(
    private navigationService: NavigationService,
    private apiService: ApiService,
    private captchaDialogService: CaptchaDialogService,
    protected storeService: StoreService
  ) {}

  backButtonAction() {
    this.navigationService.changeSposobNadaniaStepNumberTo(0);
    this.navigationService.changeScreenTo(ScreenType.STRONA_GLOWNA);
    this.storeService.resetCache();
  }

  async getLabel() {
    try {
      const labelRequest = this.buildLabelRequest();
      const labelResponse = await firstValueFrom(
        this.apiService.submitLabelRequest(labelRequest)
      );
      this.downloadLabel(labelResponse);
    } catch (error) {
      this.handleLabelError(error);
    }
  }

  buildLabelRequest(): LabelRequest {
    return {
      shipmentNumbers: this.storeService.getShipNo()
        ? [this.storeService.getShipNo()!]
        : [],
      format: 'pdf',
      clientExt1Id: this.storeService.getPayerNo()?.toString(),
    };
  }

  downloadLabel(labelResponse?: LabelResponse) {
    if (!labelResponse?.dataB64) {
      console.error('No dataB64 in label response');
      //todo zaksa
      return;
    }

    const byteCharacters = atob(labelResponse.dataB64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${this.storeService.getShipNo()}.pdf`;
    link.click();
  }

  handleLabelError(error: any) {
    const errorResponse: ErrorResponse = {
      httpStatus: error.status,
      errorMsg: error.error.errorMsg.map((msg: any) => ({
        errorCode: msg.errorCode,
        field: msg.field,
        idRow: msg.idRow,
        errorMsgLabel: msg.errorMsgLabel,
        errorMsgArgs: msg.errorMsgArgs,
      })),
    };
    if (errorResponse?.errorMsg?.[0]?.errorCode === 'FORBIDDEN') {
      this.captchaDialogService.openCaptchaDialog();
    }
  }
}
